import React from 'react';
import styled from 'styled-components';
import SubInfo from '../subInfo';
import MainInfo from './mainInfo';
import Thumbnail from './thumbnail';

const Grid = styled.dl`
  display: grid;
  grid-template-areas:
    'thumbnail'
    'mainInfo'
    'subInfo';
  grid-auto-columns: var(--card-width);
  overflow: hidden;
  border-radius: 0.5rem;
  border: solid 0.1rem #ddd;
  &:hover {
    transition: box-shadow 0.3s;
    box-shadow: 5px 5px 10px #ddd;
  }
`;

type Props = {
  childMarkdownRemark:
    | GatsbyTypes.PostsIndexQuery['allFile']['nodes'][0]['childMarkdownRemark']
    | GatsbyTypes.TagsQuery['allFile']['nodes'][0]['childMarkdownRemark'];
  type: Page;
};

const CardSubInfo = styled(SubInfo)`
  margin: 1rem;
`;
const Card: React.VFC<Props> = ({
  childMarkdownRemark: {
    excerpt,
    frontmatter: { title, thumbnail, date, tags },
    fields: { slug },
  },
  type,
}) => (
  <section>
    <Grid>
      <Thumbnail
        title={title}
        imageSharp={
          thumbnail && (thumbnail.childImageSharp as GatsbyTypes.ImageSharp)
        }
        slug={slug}
        type={type}
      />
      <MainInfo title={title} slug={slug} excerpt={excerpt} type={type} />
      <CardSubInfo date={date} tags={tags as string[]} type={type} />
    </Grid>
  </section>
);

export default Card;
